module.exports = __webpack_public_path__ + "img/abtrip_web.ed2a561a.png";